import { memo } from 'react';
import { cn, RawHtml } from '@divlab/divanui';

import ServicePageWrapper from '@Components/ServicePageWrapper';
import Img from '@UI/Img';
import Condition from './elems/Condition';
import styles from './Banner.module.css';

import type { BannerData } from '@Components/CreditSlimBanner/typings';
import type { FC, HTMLAttributes } from 'react';

export interface BannerProps extends HTMLAttributes<HTMLDivElement> {
  className?: string;
  banner: BannerData;
}

const Banner: FC<BannerProps> = (props) => {
  const { className, banner, ...restProps } = props;
  const { conditions, anchorSrc, note, list } = banner;

  return (
    <div
      {...restProps}
      className={cn(styles.banner, className)}
      style={{ background: banner.color }}
    >
      <ServicePageWrapper className={styles.container}>
        <div className={styles.left}>
          <Img
            className={styles.logo}
            cnImage={styles.logoImg}
            src={anchorSrc}
            alt={banner.name}
            loading='eager'
          />
          {list?.length > 0 && (
            <ul className={styles.list}>
              {list.map((item) => (
                <li className={styles.listItem} key={item}>
                  <RawHtml html={item} />
                </li>
              ))}
            </ul>
          )}
        </div>

        <div className={styles.right}>
          <div className={styles.digitsWrapper}>
            {conditions?.map((condition, index) => (
              <div className={styles.digitsItem} key={index}>
                {condition.title && <span className={styles.title}>{condition.title}</span>}
                {condition.items?.map((item) => (
                  <Condition
                    className={styles.item}
                    key={`${item.digit}_${item.symbol}`}
                    item={item}
                  />
                ))}
              </div>
            ))}
          </div>
          <div className={styles.note} dangerouslySetInnerHTML={{ __html: note }} />
        </div>
      </ServicePageWrapper>
    </div>
  );
};

export default memo(Banner);
